module.exports = __webpack_public_path__ + "img/eminzhongcheng.340ef571.jpg";